"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTimeDiff = exports.formatDateToUnix = exports.generateMonthAndYearArray = exports.isDateHoliday = exports.checkWorkingHoursOverlaps = exports.convertDateToCustomFormat = exports.isSunday = exports.isSaturday = exports.calculateDurationBetweenTimestampsWithFractions = exports.getNowTimestamp = exports.getMaxDate = exports.getMinDate = exports.formatToKadroDate = exports.generateDateArray = void 0;
var moment_1 = __importDefault(require("moment"));
require("moment/locale/pl");
var generateDateArray = function (from, to) {
    if (!(0, moment_1.default)(from).isValid() || !(0, moment_1.default)(to).isValid()) {
        throw new Error('One of the given dates is incorrect');
    }
    var numberOfDays = (0, moment_1.default)(to).diff(from, 'days') + 1;
    return Array.from({ length: numberOfDays }, function (_, index) {
        return (0, moment_1.default)(from).add(index, 'days').format('YYYY-MM-DD');
    });
};
exports.generateDateArray = generateDateArray;
var formatToKadroDate = function (date) { return (0, moment_1.default)(date).format('YYYY-MM-DD'); };
exports.formatToKadroDate = formatToKadroDate;
var getMinDate = function (dateA, dateB) {
    if (!dateA) {
        return dateB;
    }
    if (!dateB) {
        return dateA;
    }
    return dateA < dateB ? dateA : dateB;
};
exports.getMinDate = getMinDate;
var getMaxDate = function (dateA, dateB) {
    if (!dateA) {
        return dateB;
    }
    if (!dateB) {
        return dateA;
    }
    return dateA > dateB ? dateA : dateB;
};
exports.getMaxDate = getMaxDate;
var getNowTimestamp = function () { return (0, moment_1.default)().format('YYYY-MM-DD HH:mm:ss'); };
exports.getNowTimestamp = getNowTimestamp;
// TODO: Add tests
var calculateDurationBetweenTimestampsWithFractions = function (end, start) {
    var newEnd = end;
    if (end === null) {
        newEnd = (0, exports.getNowTimestamp)();
        return (0, moment_1.default)().diff((0, moment_1.default)(start), 'seconds') / 60;
    }
    return (0, moment_1.default)(newEnd).diff((0, moment_1.default)(start), 'seconds') / 60;
};
exports.calculateDurationBetweenTimestampsWithFractions = calculateDurationBetweenTimestampsWithFractions;
var isSaturday = function (date) { return (0, moment_1.default)(date).isoWeekday() === 6; };
exports.isSaturday = isSaturday;
var isSunday = function (date) { return (0, moment_1.default)(date).isoWeekday() === 7; };
exports.isSunday = isSunday;
var convertDateToCustomFormat = function (date, format) { return (0, moment_1.default)(date).locale('pl').format(format); };
exports.convertDateToCustomFormat = convertDateToCustomFormat;
var checkWorkingHoursOverlaps = function (workingHoursArray) {
    var today = (0, moment_1.default)().format('YYYY-MM-DD');
    var tomorrow = (0, moment_1.default)().add(1, 'days').format('YYYY-MM-DD');
    return workingHoursArray.some(function (workingHours, index) {
        return workingHoursArray.some(function (currentHours, i) {
            if (index === i)
                return false;
            var _a = __read(workingHours.split('-'), 2), start = _a[0], end = _a[1];
            var _b = __read(currentHours.split('-'), 2), startToCompare = _b[0], endToCompare = _b[1];
            var block1 = {
                startHour: "".concat(today, " ").concat(start),
                endHour: start < end ? "".concat(today, " ").concat(end) : "".concat(tomorrow, " ").concat(end),
            };
            var block2 = {
                startHour: "".concat(today, " ").concat(startToCompare),
                endHour: startToCompare < endToCompare ? "".concat(today, " ").concat(endToCompare) : "".concat(tomorrow, " ").concat(endToCompare),
            };
            return block1.startHour < block2.endHour && block1.endHour > block2.startHour;
        });
    });
};
exports.checkWorkingHoursOverlaps = checkWorkingHoursOverlaps;
var isDateHoliday = function (date, holidays) {
    return holidays.some(function (holiday) { return holiday.freeFromWork && holiday.date === date; });
};
exports.isDateHoliday = isDateHoliday;
var generateMonthAndYearArray = function (from, to) {
    var formattedFrom = (0, moment_1.default)(from).startOf('month').format('YYYY-MM-DD');
    var formattedTo = (0, moment_1.default)(to).startOf('month').format('YYYY-MM-DD');
    var diff = (0, moment_1.default)(formattedTo).diff((0, moment_1.default)(formattedFrom), 'month');
    var result = [];
    for (var i = 0; i <= diff; i++) {
        var dateObject = (0, moment_1.default)(from).add(i, 'months');
        result.push({ year: dateObject.year(), month: dateObject.month() + 1 });
    }
    return result;
};
exports.generateMonthAndYearArray = generateMonthAndYearArray;
var formatDateToUnix = function (date) { return (0, moment_1.default)(date).unix(); };
exports.formatDateToUnix = formatDateToUnix;
var getTimeDiff = function (from, to, unit, returnFloat) {
    if (returnFloat === void 0) { returnFloat = false; }
    return (0, moment_1.default)(to).diff((0, moment_1.default)(from), unit, returnFloat);
};
exports.getTimeDiff = getTimeDiff;
